import globalConfig from '../../utiles/globalConfig'
import diffType from './_type'

const page = {
  select: 'select-pay-type-page',
  pay: 'pay-page',
  bankInfo: 'bank-detail-page',
  result: `${
    globalConfig.getHrefParam('result') == 1
      ? 'result-succ-page'
      : 'result-fail-page'
  }`,
  browserPay: 'wait-page',
  web: 'web-ready-page'
}

export default {
  /**
   * event：dom事件绑定
   * key：类名
   * type：触发操作（click、change等）
   * event：触发上报事件名
   * newPage：是否会导致页面跳转，如果true，则页面跳转会上报jump-page，否则上报leave-page
   * pageName: 固定的上报页面，非固定页面的不用填，自动使用上一次上报页面
   */
  event: {
    'j-huawei-way-dcount': [
      {
        type: 'click',
        event: 'click-select-huawei-pay-btn',
        newPage: true,
        pageName: page.select
      }
    ],
    'j-google-way-dcount': [
      {
        type: 'click',
        event: 'click-select-google-pay-btn',
        newPage: true,
        pageName: page.select
      }
    ],
    'j-thrid-way-dcount': [
      {
        type: 'click',
        event: 'click-select-third-pay-btn',
        pageName: page.select
      }
    ],
    'j-paytype-dcount': [
      {
        type: 'click',
        event: 'click-open-channel-list-btn',
        pageName: page.pay
      }
    ],
    'j-area-dcount': [
      {
        type: 'click',
        event: 'click-open-area-list-btn',
        pageName: page.pay
      }
    ],
    'j-money-dcount': [
      {
        type: 'click',
        event: 'click-open-money-list-btn',
        pageName: page.pay
      }
    ],
    'j-select-money': [
      {
        type: 'click',
        event: 'click-update-money',
        pageName: page.pay
      }
    ],
    'j-select-area': [
      {
        type: 'click',
        event: 'click-update-area',
        pageName: page.pay
      }
    ],
    'j-select-payType': [
      {
        type: 'click',
        event: 'click-update-channel',
        pageName: page.pay
      }
    ],
    'j-toogle-child-payType': [
      {
        type: 'click',
        event: 'click-open-child-channel',
        pageName: page.pay
      }
    ],
    'j-go-feeback-btn': [
      {
        type: 'click',
        event: 'click-go-feeback-btn'
      }
    ],
    'j-restore-btn': [
      {
        type: 'click',
        event: 'click-go-restore-btn',
        newPage: true
      }
    ],
    'j-goback-game-btn': [
      {
        type: 'click',
        event: 'click-goback-game-btn'
      }
    ],
    'j-thrid-way-dcount-load': [
      {
        type: 'click',
        event: 'click-select-third-pay-load-btn',
        pageName: page.select
      }
    ],
    'j-daichong': [
      {
        type: 'click',
        event: 'click-daichong-btn',
        pageName: page.select
      }
    ],
    'j-service-float-btn': [
      {
        type: 'click',
        event: 'click-service-float-btn',
        newPage: true
      }
    ],
    'j-open-jiama-popup': [
      {
        type: 'click',
        event: 'click-open-jiama-popup-btn',
        pageName: page.pay
      }
    ],
    submitLoading: [
      {
        type: 'click',
        event: 'click-submit-btn',
        newPage: true,
        pageName: page.pay
      }
    ],
    laddingFinish: [
      {
        type: 'auto',
        event: 'auto-go-pay-page',
        pageName: page.select
      }
    ],
    'j-cancle-tip-btn': [
      {
        type: 'click',
        event: 'click-popup-cancel-btn'
      }
    ],
    'j-sure-tip-btn': [
      {
        type: 'click',
        event: 'click-popup-sure-btn'
      }
    ],
    'j-close-tip-btn': [
      {
        type: 'click',
        event: 'click-popup-close-btn'
      }
    ],
    'j-save-card-btn': [
      {
        type: 'click',
        event: 'click-save-card-btn',
        pageName: page.pay
      }
    ],
    'j-edit-card-btn': [
      {
        type: 'click',
        event: 'click-edit-card-btn',
        pageName: page.pay
      }
    ],
    'j-delete-card-btn': [
      {
        type: 'click',
        event: 'click-delete-card-btn',
        pageName: page.pay
      }
    ],
    'j-open-card-list': [
      {
        type: 'click',
        event: 'click-open-card-list-btn',
        pageName: page.pay
      }
    ],
    'j-select-card': [
      {
        type: 'click',
        event: 'click-select-card-btn',
        pageName: page.pay
      }
    ],
    'j-select-new-card': [
      {
        type: 'click',
        event: 'click-select-new-card-btn',
        pageName: page.pay
      }
    ],
    'j-select-coupon-entry': [
      {
        type: 'click',
        event: 'click-select-coupon-entry',
        pageName: page.pay
      }
    ],
    'j-select-coupon-item': [
      {
        type: 'click',
        event: 'click-select-coupon-item',
        pageName: page.pay
      }
    ],
    'j-click-coupon-use': [
      {
        type: 'click',
        event: 'click-coupon-use',
        pageName: page.pay
      }
    ],
    'j-click-coupon-close': [
      {
        type: 'click',
        event: 'click-coupon-popup-close',
        pageName: page.pay
      }
    ],
    'j-click-coupon-confirm-sure': [
      {
        type: 'click',
        event: 'click-coupon-confirm-sure',
        pageName: page.pay
      }
    ],
    'j-click-coupon-confirm-cancel': [
      {
        type: 'click',
        event: 'click-coupon-confirm-cancel',
        pageName: page.pay
      }
    ],
    'j-credit-card-item': [
      {
        type: 'click',
        event: 'click-credit-card-choose',
        pageName: page.event
      }
    ]
  },
  /**
   * enter：组件created时触发
   * key：组件name
   * event：触发上报事件名，统一前缀会加上‘enter-。当event为空时不上报
   * ！！！请确保组件名在同一入口页面内唯一
   */
  // enter: {
  //   payPage: { event: "pay-page" },
  //   resultPage: {
  //     event: `${globalConfig.getHrefParam("result") == 1 ? "result-succ-page" : "result-fail-page"}`,
  //   },
  //   selectPayTypePage: { event: "select-pay-type-page" },
  //   waitPage: { event: "wait-page" },
  //   BankDetailInfoPage: { event: "bank-detail-page" },
  // },
  /**
   * router:路由更新时触发，这个需要在入口手动触发方法
   * key：路由名
   * event：触发上报事件名，统一前缀会加上‘enter-。当event为空时不上报
   */
  router: {
    select: { event: page.select },
    pay: { event: page.pay },
    bankInfo: { event: page.bankInfo },
    result: {
      event: page.result
    },
    browserPay: { event: page.browserPay },
    web: { event: page.web }
  },
  /**
   * observer：属性监听
   * key：属性名
   * pre、now：属性变更时判断是否上报，两者必须同时设置，pre为上一值，now为当前值，判断采用===。两者都不设的时候，判断方式为上一值！==当前值
   * action：符合条件时动作，enter：触发enter，key相同；event：触发event，key相同
   * type：属性类型，可选computed，data（包括data和watch）
   * page:属性所属vue的名称
   * staticCondition:静态条件，key为属性名，value为目标属性值。属性限同组件下的data或者watch.该配置目前只限type=data下使用
   */
  observer: {
    submitLoading: {
      pre: false,
      now: true,
      action: 'event',
      type: 'data',
      page: 'payPage',
      diffType: diffType.equal
    },
    laddingFinish: {
      pre: false,
      now: true,
      action: 'event',
      type: 'data',
      page: 'selectPayTypePage',
      diffType: diffType.equal,
      staticCondition: {
        websitePage: true
      }
    }
  }
}
